export default "__VITE_ASSET__CFmg2Ijp__"